import {
  MASTER_CALENDAR_REQUEST,
  MASTER_CALENDAR_SUCCESS,
  MASTER_CALENDAR_FAILURE,
  MASTER_CALENDAR_CLEAR,
} from '../actions/actionTypes';

const initialState = { events: [], loading: false, error: null };

export const masterCalendarReducer = (state = initialState, action) => {
  switch (action.type) {
    case MASTER_CALENDAR_REQUEST: return { ...state, loading: true, error: null };
    case MASTER_CALENDAR_SUCCESS: return { ...state, loading: false, events: action.payload };
    case MASTER_CALENDAR_FAILURE: return { ...state, loading: false, error: action.payload };
    case MASTER_CALENDAR_CLEAR:   return initialState;
    default: return state;
  }
};
